<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText"
      size="normal">
    <template #header>
      <span>导入报价</span>
    </template>
    <template #content>
      <gj-upload
          :template-url="`/supply/supplier/download/import/quote/template`"
          @uploadAfter="uploadAfter"
          container-type="supplierQuotedPrice"
          style="margin-bottom: 12px;"
      >
        <template #tip>
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
          :rules="[
            '每行只允许填写一个SKU，一个供应商若报价多个SKU，请分行填写',
            '同一个供应商名称或同一个SKU存在多条报价记录，以第一条记录为准',
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, uploadMixin, userGuideMixin} from "../../../../../minxins";
  import {importSupplierQuotedPrice} from "../../../../../api/purchase";

  export default {
    name: "supplier-import-quoted-price",
    mixins: [modalMixIn, uploadMixin, userGuideMixin],
    methods: {
      uploadAfter(attId, data, uploadCb) {
        this.importHandleLoading = true;
        importSupplierQuotedPrice(attId)
          .then((res) => {
            this.$gjImportHandle(res, uploadCb)
            this.$emit('userGuide');
          }).catch(() => {
            uploadCb('error')
          }).complete(() => this.importHandleLoading = false)
      }
    }
  }
</script>

<style scoped>

</style>
